import React, { memo, useCallback, useEffect, useState } from "react";
import "./football.m.css";

const SCHEDULE_API =
  "https://production-dmu-api-origin.s3.eu-west-1.amazonaws.com/v2/gn-feeds/data/football-schedule.json";

function FootballCta({ text }) {
  const [matches, setMatches] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  const fetchSchedule = useCallback(async () => {
    try {
      const res = await fetch(SCHEDULE_API);
      const data = await res.json();
      const items = data?.response?.items || [];
      setMatches(items);
    } catch (err) {
      console.error("[FootballCta] Failed to fetch schedule:", err);
    }
  }, []);

  // Fetch on mount and poll every 2 minutes
  useEffect(() => {
    fetchSchedule();
    const poll = setInterval(fetchSchedule, 120000);
    return () => clearInterval(poll);
  }, [fetchSchedule]);

  // Cycle through matches every 10 seconds
  useEffect(() => {
    if (matches.length <= 1) return;
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % matches.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [matches.length]);

  const currentMatch = matches[currentIndex];

  const renderMatch = () => {
    if (!currentMatch) return null;
    const { home, away } = currentMatch.teams;
    return (
      <>
        <img src={home.logo} alt={home.tname} styleName="team-flag" />
        <span styleName="team-name">{home.abbr}</span>
        <span styleName="match-vs">vs</span>
        <span styleName="team-name">{away.abbr}</span>
        <img src={away.logo} alt={away.tname} styleName="team-flag" />
      </>
    );
  };

  return (
    <a styleName="football-cta-widget" href="/fifa-world-cup-2026-live-score">
      <span styleName="cta-icon">⚽</span>
      <span styleName="cta-text">
        {currentMatch ? (
          <span styleName="match-row" key={currentMatch.mid}>{renderMatch()}</span>
        ) : (
          <span styleName="cta-fallback">{text.toUpperCase()}</span>
        )}
      </span>
      <span styleName="cta-live">
        <svg styleName={`live-dot${currentMatch ? " live-dot-pulse" : ""}`} xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8" fill="none">
          <circle cx="4" cy="4" r="4" fill="#006219" />
        </svg>
        Live
      </span>
    </a>
  );
}

export default memo(FootballCta);
